module.exports = __webpack_public_path__ + "img/1493012546.09fa3630.jpg";